module.exports = __webpack_public_path__ + "static/01-4566c286646238936442af509db78c10.jpg";